import React from "react";
import {Spin} from "antd";
import Header from "../../components/Header";
import Card from "../../components/Card";
import {withFirebase} from '../../context/firebaseContext'

import s from './CurrentCard.module.scss'

class CurrentCard extends React.PureComponent {
    state = {
        word: {
            id: 0,
            eng: '',
            rus: '',
            img: '',
        }
    }

    componentDidMount() {
        const {firebase, match: {params}} = this.props;
        if (params.id) {
            firebase.getUserCurrentCardsRef(params.id).once('value').then(res => {
                this.setState({
                    word: res.val(),
                });
            })
        } else {
            return (
                <div>404 Page</div>
            )
        }
    }

    render() {
        const {word: {eng, rus, img }} = this.state;

        if (eng === '' && rus === '') {
            return <div className={s.root}><Spin/></div>
        }
        return (
            <div className={s.root}>
                <Header>
                    This is our Current Card - {eng}
                </Header>
                <Card eng={eng} rus={rus} img={img}/>
            </div>
        );
    }
};

export default withFirebase(CurrentCard);